var exports = {
  "l": "Dialog__tbYFAF",
};

module.exports = exports;
